<template>
    <div class="col-12">
        <confirm-box ref="confirmBox"></confirm-box>
        <h4 class="h4 text-primary mb-0">Enrollment for {{ classItem.name }}</h4>
        <h6 class="h6 text-secondary">{{ classItem.district_name }}</h6>
        <multiselect
            v-model="studentsEnrolled"
            :searchable="true"
            :options="studentsAvailable"
            :multiple="true"
            :loading="isLoading"
            :options-limit="50"
            :internal-search="false"
            :clear-on-select="false" 
            :close-on-select="false" 
            :custom-label="showStudents"
            placeholder="Select students.."
            track-by="id"
            label="name"
            @search-change="search"
            @remove="askRemove"
        >
        </multiselect>
        <div class="text-muted">Begin typing to search for students by first or last name. Multiple students may be added to a class.</div>
        <div class="mt-3">
            <cancel-submit-button
                @submit="submit()"
                @cancel="cancel()"
            ></cancel-submit-button>
        </div>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CancelSubmitButton from './CancelSubmitButton.vue';
import ConfirmBox from './ConfirmBox.vue';

export default {
    components: { Multiselect, CancelSubmitButton, ConfirmBox },

    props: {
        classItem: {
            type: Object,
            default(data={}) {
                return {
                    id: data.id ?? null,
                    name: data.name ?? '',
                    grading_period: data.grading_period ?? '',
                    district_id: data.district_id ?? null,
                    district_name: data.district_name ?? '',
                    status: data.status ?? 1
                };
            }
        },
    },

    data() {
        return {
            studentsEnrolled: [],
            studentsAvailable: [],
            isLoading: false,
            searchTimeout: 0
        }
    },

    mounted() {
        this.$parent.isLoading = true;
        axios
            .get(`/api/classes/enroll/${this.classItem.id}`)
            .then((response) => {
                this.studentsEnrolled = response.data;
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                this.$parent.isLoading = false;
            });
    },

    methods: {
        search: function(text) {
            clearTimeout(this.searchTimeout);

            this.changeTimeout = setTimeout(() => {
                if (!text) {
                    return;
                }

                this.isLoading = true;
                axios
                    .get(`/api/students?search=${text}&limit=25&district=${this.classItem.district_id}`)
                    .then((response) => {
                        this.studentsAvailable = response.data.students;
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }, 1000);
        },

        cancel: function() {
            this.$parent.enrolling = -1;
        },

        submit: function() {
            this.$parent.isLoading = true;
            const students = this.studentsEnrolled.map(st => st.id);
            axios
                .put(`/api/classes/enroll/${this.classItem.id}`, { students: students })
                .then((response) => {
                    this.$parent.enrolling = -1;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });

        },

        showStudents: function(student) {
            if (student.number) {
                return `${student.first_name} ${student.last_name} (${student.number})`;
            } else {
                return `${student.first_name} ${student.last_name}`;
            }
            
        },

        askRemove: function(student, id) {
            console.log(student);
            console.log(id);
            console.log('REMOVED');

            const data = {
                content: `Are you sure you would like to remove <b>${student.last_name}, ${student.first_name}</b> from this group?`,
                title: 'Remove Student',
                declined: () => {
                    this.studentsEnrolled.push(student);
                }
            };
            this.$refs.confirmBox.show(data);
        }
    }

}
</script>